import { render, staticRenderFns } from "./Jnb.vue?vue&type=template&id=12ea9d88&scoped=true"
import script from "./Jnb.vue?vue&type=script&lang=js"
export * from "./Jnb.vue?vue&type=script&lang=js"
import style0 from "./Jnb.vue?vue&type=style&index=0&id=12ea9d88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ea9d88",
  null
  
)

export default component.exports